import { render, staticRenderFns } from "./resources-list.vue?vue&type=template&id=3f38f0ef&scoped=true"
import script from "./resources-list.vue?vue&type=script&lang=js"
export * from "./resources-list.vue?vue&type=script&lang=js"
import style0 from "./resources-list.vue?vue&type=style&index=0&id=3f38f0ef&prod&lang=scss&scoped=true"
import style1 from "./resources-list.vue?vue&type=style&index=1&id=3f38f0ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38f0ef",
  null
  
)

export default component.exports